import { render, staticRenderFns } from "./MdinEdit.vue?vue&type=template&id=1c6facbc&scoped=true&"
import script from "./MdinEdit.vue?vue&type=script&lang=js&"
export * from "./MdinEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6facbc",
  null
  
)

export default component.exports